<template>
  <div
    class="d-flex overlay-container"
  >
    <div class="search-shortcuts-container">
      <div
        id="search-container"
        class="d-flex shortcut-search-container"
      >
        <div class="shortcut-search-input">
          <b-form-input
            id="basicInput"
            v-model="searchInput"
            class="p-1"
            :placeholder="$t('navigation.search-shortcuts')"
          />
        </div>
      </div>
      <div
        class="d-flex flex-column shortcut-container-full"
      >
        <template
          v-for="section in filtered_sections"
        >
          <div
            :key="section.key"
            v-if="canViewSection(section)"
            class="d-flex w-100 shortcuts-container"
          >
            <div class="d-flex justify-content-center justify-content-center shortcut-title-container">
              <span class="shortcut-section-title m-auto text-bold font-weight-800">{{ $t(section.title) }}</span>
            </div>
            <div class="d-flex shortcut-sections-container flex-wrap">
              <template v-for="shortcut in section.sections">
                <ShortcutCard
                  :key="shortcut.key"
                  :type="section.key"
                  :shortcut="shortcut"
                  :icons="SHORTCUTS_ICONS"
                  :title="$t(shortcut.title)"
                />
              </template>
            </div>

          </div>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
import {
  BFormInput,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import PermissionMixin from '@/mixins/permission-mixin'
import ShortcutCard from '@/@okmenu/components/cards/ShortcutCard'
import SHORTCUTS_SECTIONS, { SHORTCUTS_ICONS } from '@/constants/shortcuts'
import { getShortcutPermission } from '@/utils/shortcut-permissions'

import BusinessTypeMixin from '@/mixins/business-type-mixin'

export default {
  name: 'Shortcuts',
  components: {
    ShortcutCard,
    BFormInput,
  },
  mixins: [PermissionMixin, BusinessTypeMixin],
  props: {
  },
  data() {
    return {
      modalVisible: true,
      loading: false,
      SHORTCUTS_SECTIONS,
      SHORTCUTS_ICONS,
      searchInput: null,
    }
  },
  computed: {
    ...mapGetters({
      showShortcuts: 'navigation/showShortcuts',
      isGoogleViralPurchased: 'subscription/isGoogleViralPurchased',
      isBrandedDomainPurchased: 'subscription/isBrandedDomainPurchased',
      isMobileAppPurchased: 'subscription/isMobileAppPurchased',
      addons: 'pricing/addons',
      user: 'auth/user',
    }),
    filtered_sections() {
      const vm = this
      if (!vm.searchInput || vm.searchInput.length === 0) {
        return vm.SHORTCUTS_SECTIONS
      }
      const filtered = []
      const shortcuts = cloneDeep(vm.SHORTCUTS_SECTIONS)
      shortcuts.forEach(item => {
        const filteredShortCuts = item.sections.filter(sh => this.$t(sh.title).toLowerCase().indexOf(vm.searchInput.toLowerCase()) !== -1)
        if (filteredShortCuts.length) {
          const temp = item
          temp.sections = filteredShortCuts
          filtered.push(temp)
        }
      })
      return filtered
    },
  },
  mounted() {
    this.getAddons()
  },
  methods: {
    canViewSection(section) {
      if (section.ownerOnly) return this.isPrimaryAccount
      return section.sections.some(shortcut => this.canViewShortcut(shortcut))
    },
    canViewShortcut(shortcut) {
      if (this.isPrimaryAccount) return true
      const permissions = getShortcutPermission(shortcut)
      if (!permissions) return true
      const list = Array.isArray(permissions) ? permissions : [permissions]
      return this.hasAnySubuserPermission(list)
    },
    toggleShortcuts() {
      this.$store.commit('navigation/SET_SHOW_SHORTCUTS', false)
    },
    getAddons() {
      this.$store.dispatch('pricing/FETCH_PRICING', false).then(() => {
      })
    },
  },
  metaInfo() {
    return {
      title: this.$t('navigation.shortcuts'),
    }
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/utils/responsive.scss";

.overlay {
  position: fixed; /* Sit on top of the page content */
  display: block; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.7); /* Black background with opacity */
  z-index: 1032; /* Specify a stack order in case you're using a different order for other elements */
  //cursor: pointer; /* Add a pointer on hover */
  overflow-y: auto;
}
.overlay-container {
  padding: 10px 25px 8px 10px;
  flex-direction: column;
  background: #fff;
  .dark-layout & {
    background: #283046;
  }
  @include respond-to-max('medium') {
    align-items: baseline;
    padding: 10px 0 25px 0;
  }
}
.logo-container {
  display: flex;
  padding: 15px;
}
.search-shortcuts-container {
  display: flex;
  flex-direction: column;
  //@include respond-to-max('medium') {
  //  flex-direction: column;
  //}
}
.shortcut-container-full {
  min-width: 80%;
  @include respond-to-max('medium') {
    margin-top: 2px ;
    margin-left: 5px ;
    margin-right: 5px ;
  }
}
.shortcuts-container {
  border-radius: 10px;
  padding: 10px;
  margin-top: 8px;
  min-height: 92px;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.95)), #4B465C;;
  .dark-layout & {
    background: #666666;
  }
  @include respond-to-max('medium') {
    flex-direction: column;
  }
}
.shortcut-title-container{
  width: 15%;
  color: #6E6B7B;
  .dark-layout & {
    color: #FFFFFF;
  }
  @include respond-to-max('medium') {
    width: 100%;
  }
}
.shortcut-sections-container{
  width: 85%;
  @include respond-to-max('medium') {
    width: 100%;
  }
}
.shortcut-search-container{
  margin-top: 3px;
  width: 22%;
  max-width: 255px;
  align-items: center;
  height: fit-content;
  @include respond-to-max('medium') {
    width: 80%;
    margin-left: 5px ;
    margin-right: 5px ;
  }
}
.shortcut-search-input {
  width: 74%;
  @include respond-to-max('medium') {
    width: 88%;
  }
}
.shortcut-section-title {
  padding: 9px;
}

</style>
